import { getCurrentDate } from "../../../lib/formatter/Formatter";
import ExcelJS from "exceljs";

export const FilePersonToPerson = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  const data = [
    ["NAME OF COMPANY", "", "", "", "", "", "", "", "", "", ""],
    ["MLHUILLIER TRANSACTION", "", "", "", "", "", "", "", "", "", ""],
    ["DATE", "YYYY-MM-DD", "", "", "", "", "", "", "", "", "", ""],
    [
      "BATCH NO.",
      "[COMPANY ACRONYM]_YYYYMMDDHH_001",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [
      "TOTAL TRXN COUNT (PHP/USD)",
      { formula: "COUNTA(L9:L1048576)", result: 0 },
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [
      "TOTAL PRINCIPAL (PHP/USD)",
      { formula: "SUM(L9:L1048576)", result: 0 },
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [],
    [
      "REFERENCE #",
      "SENDER LAST NAME",
      "SENDER FIRST NAME",
      "SENDER MIDDLE NAME",
      "SENDER ADDRESS",
      "SENDER CONTACT #",
      "RECEIVER LAST NAME",
      "RECEIVER FIRST NAME",
      "RECEIVER MIDDLE NAME",
      "RECEIVER ADDRESS",
      "RECEIVER CONTACT #",
      "PRINCIPAL AMOUNT",
    ],
  ];

  // Add rows
  data.forEach((row) => {
    const newRow = worksheet.addRow(row);
    newRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "left" };
    });
  });

  // Bold key labels
  [1, 2, 3, 4, 5, 6, 7].forEach((rowNum) => {
    worksheet.getRow(rowNum).eachCell((cell) => {
      cell.font = { bold: true };
    });
  });

  // Set column widths
  worksheet.columns = [
    { width: 30 }, // NAME OF COMPANY
    { width: 20 }, // Empty Column
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
  ];

  // Add border for header (row 7)
  worksheet.getRow(7).eachCell((cell: any) => {
    cell.font = { bold: true };
    cell.alignment = { vertical: "middle", horizontal: "left" };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "TemplateV1.xlsx";
  link.click();
  URL.revokeObjectURL(link.href);
};

export const FileBusinessToPerson = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  const data = [
    ["NAME OF COMPANY", "", "", "", "", "", "", "", "", "", ""],
    ["MLHUILLIER TRANSACTION", "", "", "", "", "", "", "", "", "", ""],
    ["DATE", "YYYY-MM-DD", "", "", "", "", "", "", "", "", "", ""],
    [
      "BATCH NO.",
      "[COMPANY ACRONYM]_YYYYMMDDHH_001",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [
      "TOTAL TRXN COUNT (PHP/USD)",
      { formula: "COUNTA(H9:H1048576)" },
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [
      "TOTAL PRINCIPAL (PHP/USD)",
      { formula: "SUM(H9:H1048576)" },
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [],
    [
      "REFERENCE #",
      "SENDER BUSINESS NAME",
      "RECEIVER LAST NAME",
      "RECEIVER FIRST NAME",
      "RECEIVER MIDDLE NAME",
      "RECEIVER ADDRESS",
      "RECEIVER CONTACT #",
      "PRINCIPAL AMOUNT",
    ],
  ];

  // Add rows
  data.forEach((row) => {
    const newRow = worksheet.addRow(row);
    newRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "left" };
    });
  });

  // Bold key labels
  [1, 2, 3, 4, 5, 6, 7].forEach((rowNum) => {
    worksheet.getRow(rowNum).eachCell((cell) => {
      cell.font = { bold: true };
    });
  });

  // Set column widths
  worksheet.columns = [
    { width: 30 }, // NAME OF COMPANY
    { width: 20 }, // Empty Column
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
  ];

  // Add border for header (row 7)
  worksheet.getRow(7).eachCell((cell: any) => {
    cell.font = { bold: true };
    cell.alignment = { vertical: "middle", horizontal: "left" };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "TemplateV2.xlsx";
  link.click();
  URL.revokeObjectURL(link.href);
};

export const FileV3 = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  const data = [
    ["NAME OF COMPANY", "", "", "", "", "", "", "", "", "", ""],
    ["MLHUILLIER TRANSACTION", "", "", "", "", "", "", "", "", "", ""],
    ["DATE", getCurrentDate(), "", "", "", "", "", "", "", "", "", ""],
    [
      "BATCH NO.",
      "[COMPANY ACRONYM]_YYYYMMDDHH_001",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [
      "TOTAL TRXN COUNT (PHP/USD)",
      { formula: "COUNTA(I8:L1048576)" },
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [
      "TOTAL PRINCIPAL (PHP/USD)",
      { formula: "SUM(I8:L1048576)" },
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
    ],
    [],
    [
      "REFERENCE #",
      "SENDER BUSINESS NAME ",
      "RECEIVER LAST NAME",
      "RECEIVER FIRST NAME",
      "RECEIVER MIDDLE NAME",
      "RECEIVER ADDRESS",
      "RECEIVER CONTACT #",
      "PRINCIPAL AMOUNT",
    ],
  ];

  // Add rows
  data.forEach((row) => {
    const newRow = worksheet.addRow(row);
    newRow.eachCell((cell) => {
      cell.alignment = { vertical: "middle", horizontal: "left" };
    });
  });

  // Bold key labels
  [1, 2, 3, 4, 5, 6, 7].forEach((rowNum) => {
    worksheet.getRow(rowNum).eachCell((cell) => {
      cell.font = { bold: true };
    });
  });

  // Set column widths
  worksheet.columns = [
    { width: 30 }, // NAME OF COMPANY
    { width: 20 }, // Empty Column
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
  ];

  // Add border for header (row 7)
  worksheet.getRow(7).eachCell((cell: any) => {
    cell.font = { bold: true };
    cell.alignment = { vertical: "middle", horizontal: "left" };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "TemplateV3.xlsx";
  link.click();
  URL.revokeObjectURL(link.href);
};
